export default "__VITE_ASSET__CB_ShmAL__"